// extracted by mini-css-extract-plugin
export default {"title":"EngenerData_title__M8XI-","block":"EngenerData_block__DbCfF"};